import React from "react";
import { motion } from "framer-motion";
import { experience } from "../../data/portfolio";

export const Experience = () => {
  return (
    <section id="experience" data-testid="experience-section" className="relative py-24 md:py-32 border-t border-white/5">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="mb-14">
          <div className="text-xs font-mono-display uppercase tracking-widest text-[color:var(--primary)] mb-3">
            /03 · Journey
          </div>
          <h2 className="font-mono-display text-3xl sm:text-4xl lg:text-5xl tracking-tight font-semibold">
            13+ years of <span className="text-gradient-neon">delivering</span>.
          </h2>
        </div>

        <div className="relative">
          {/* rail */}
          <div className="absolute left-4 md:left-6 top-2 bottom-2 w-[2px] rail opacity-70" aria-hidden />

          <div className="space-y-10">
            {experience.map((exp, i) => (
              <motion.div
                key={exp.company + exp.period}
                initial={{ opacity: 0, x: -20 }}
                whileInView={{ opacity: 1, x: 0 }}
                viewport={{ once: true, amount: 0.2 }}
                transition={{ duration: 0.5, delay: i * 0.05 }}
                data-testid={`experience-item-${i}`}
                className="relative pl-12 md:pl-16"
              >
                {/* dot */}
                <div className="absolute left-2 md:left-4 top-2 w-4 h-4 rounded-full bg-[color:var(--primary)] glow-cyan pulse-ring" aria-hidden />

                <div className="glass rounded-2xl p-6 md:p-8 hover:border-[color:var(--primary)]/40 transition-all">
                  <div className="flex flex-col md:flex-row md:items-baseline md:justify-between gap-2">
                    <div>
                      <div className="font-mono-display text-lg md:text-xl text-white">{exp.role}</div>
                      <div className="text-sm text-[color:var(--primary)] font-mono-display">{exp.company}</div>
                    </div>
                    <div className="text-xs font-mono-display uppercase tracking-widest text-white/50">
                      {exp.period} · {exp.location}
                    </div>
                  </div>

                  <div className="mt-2 text-xs font-mono-display tracking-widest uppercase text-[color:var(--accent)]">
                    {exp.tag}
                  </div>

                  <ul className="mt-5 space-y-2 text-sm md:text-base text-white/75 font-body">
                    {exp.highlights.map((h, idx) => (
                      <li key={idx} className="flex gap-3">
                        <span className="text-[color:var(--accent)] mt-1">›</span>
                        <span>{h}</span>
                      </li>
                    ))}
                  </ul>
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Experience;